import { useContext } from "react";
import "./customer-home-menu.styles.scss";
import { CustomerMenuContext } from "../../../contexts/customerMenu.context";
import CHMItem from "./chm-item/chm-item.component";
const CustomerHomeMenu = () => {
  const { customerMenuContext } = useContext(CustomerMenuContext);
  return (
    <div className="chm-container">
      {Object.keys(customerMenuContext).map((index) => {
        if (index !== "metadata" && index !== "hotelID") {
          return (
            <CHMItem
              key={index}
              itemDetails={customerMenuContext[index]}
              itemName={index}
            />
          );
        }
      })}
    </div>
  );
};
export default CustomerHomeMenu;
